var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message"},[_vm._v(" We are missing data to display this slide, complete more tasks in order to make it available. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }